var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPromoCodeFilled = function SvgPromoCodeFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promo Code Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66631 0.515375C9.08514 0.440866 8.50224 0.639836 8.08792 1.05415L1.55414 7.58794C0.815288 8.32679 0.815288 9.5247 1.55414 10.2635L6.23645 14.9459C6.9753 15.6847 8.17321 15.6847 8.91206 14.9459L15.4458 8.41208C15.8602 7.99776 16.0591 7.41486 15.9846 6.83369L15.4525 2.68345C15.343 1.82937 14.6706 1.15695 13.8165 1.04746L9.66631 0.515375ZM10.5845 5.91826C11.1387 6.4724 12.0371 6.4724 12.5912 5.91826C13.1454 5.36413 13.1454 4.46569 12.5912 3.91156C12.0371 3.35742 11.1387 3.35742 10.5845 3.91156C10.0304 4.46569 10.0304 5.36413 10.5845 5.91826Z",
    fill: "#666666"
  }))));
};
export default SvgPromoCodeFilled;